<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>

        <!-- Page header -->
        <v-flex xs12>
          <div class="modern-page-header">
            <div class="modern-page-header__left">
              <div class="modern-page-header__icon-wrap">
                <v-icon class="modern-page-header__icon">school</v-icon>
              </div>
              <div>
                <h3 class="modern-page-header__title">Schools</h3>
                <p class="modern-page-header__sub">Launch and manage school portals</p>
              </div>
            </div>
            <div class="modern-page-header__actions">
              <v-btn color="primary" depressed class="modern-add-btn" @click="handleCreateNew()">
                <v-icon left small>add</v-icon>
                Register School
              </v-btn>
            </div>
          </div>
        </v-flex>

        <v-flex lg12>
          <v-card class="modern-table-card">
            <div class="modern-table-toolbar">
              <div class="modern-search-wrap">
                <v-icon class="modern-search-icon">search</v-icon>
                <input
                  v-model="search"
                  class="modern-search-input"
                  placeholder="Search schools..."
                />
              </div>
            </div>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                item-key="name"
                class="modern-data-table"
              >
                <template slot="items" slot-scope="props">
                  <tr class="table-row-clickable">
                    <td class="table-cell-primary" @click="handleMoreInfo(props.item)">
                      <div class="school-name-cell">
                        <div class="school-avatar">
                          {{ props.item.company_name ? props.item.company_name[0].toUpperCase() : 'S' }}
                        </div>
                        <span>{{ props.item.company_name }}</span>
                      </div>
                    </td>
                    <td class="table-cell-secondary" @click="handleMoreInfo(props.item)">
                      {{ props.item.email }}
                    </td>
                    <td>
                      <v-chip
                        small
                        :color="props.item.company_sub_type == 1 ? 'blue lighten-5' : 'purple lighten-5'"
                        :text-color="props.item.company_sub_type == 1 ? 'blue darken-2' : 'purple darken-2'"
                        class="level-chip"
                      >
                        {{ props.item.company_sub_type == 1 ? 'Primary' : 'Secondary' }}
                      </v-chip>
                    </td>
                    <td class="table-cell-secondary">
                      {{ dateDiff(new Date(), new Date(props.item.created_date)) }} days
                    </td>
                    <td class="table-cell-secondary">
                      {{ new Date(props.item.created_date).toLocaleDateString() }}
                    </td>
                    <td class="table-cell-actions" align="right">
                      <v-btn
                        small
                        flat
                        color="warning"
                        class="table-action-btn"
                        @click="launchEmergency(props.item)"
                      >
                        <v-icon left x-small>warning</v-icon>Emergency
                      </v-btn>
                      <v-btn
                        small
                        depressed
                        color="primary"
                        class="table-action-btn table-action-btn--primary"
                        @click="loginToServer(props.item)"
                      >
                        <v-icon left x-small>launch</v-icon>Launch
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  <div class="modern-empty-state">
                    <v-icon class="modern-empty-state__icon">school</v-icon>
                    <p class="modern-empty-state__text">No schools found</p>
                    <v-btn color="primary" depressed small @click="handleCreateNew()">Register First School</v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import APICompany from "@/mixins/APICompany";
import Domain from "@/mixins/domain";
export default {
  mixins: [APICompany, Domain],
  data() {
    return {
      search: "",
      complex: {
        selected: [],
        headers: [
          { text: "School Name", value: "company_name" },
          { text: "Email", value: "email" },
          { text: "Level", value: "company_sub_type" },
          { text: "Days Active", value: "" },
          { text: "Created On", value: "created_date" },
          { text: "", value: "", sortable: false }
        ],
        items: []
      }
    };
  },
  created() {
    this.handleGet();
  },
  methods: {
    dateDiff: function(date1, date2) {
      date1.setHours(0);
      date1.setMinutes(0, 0, 0);
      date2.setHours(0);
      date2.setMinutes(0, 0, 0);
      var datediff = Math.abs(date1.getTime() - date2.getTime());
      return parseInt(datediff / (24 * 60 * 60 * 1000), 10);
    },
    handleGet: async function() {
      try {
        this.complex.items = await this.getCompanies();
      } catch (error) {
        this.$toast.error("Cannot get details!", "Error", { position: "topCenter" });
      }
    },
    handleCreateNew: function() {
      const userId = 0;
      this.$router.push({ path: `companies/create/${userId}` });
    },
    handleMoreInfo: function(row) {
      this.$router.push({
        name: "Companies Create",
        params: { object: row, id: row._id }
      });
    },
    loginError: function() {
      this.$toast.error(
        "Failed to proceed with launching school portal, Try again.",
        "Error",
        { position: "topCenter" }
      );
    },
    launchEmergency: async function(company) {
      let url = "https://portal.edpass.co/mobile/" + company.company_id;
      window.open(url, "_blank");
    },
    loginToServer: async function(company) {
      if (!company && !company._id) {
        this.loginError();
        return;
      }
      try {
        let response = await this.authCompany(company._id);
        let link = Domain.PORTAL_DOMAIN;
        let options = {};
        options.token = response.token;
        options.url = response.url;
        options.domain = response.domain;
        options.port = response.port;
        options = btoa(JSON.stringify(options));
        let url = link + "/#/login?key=" + options;
        window.open(url, "_blank");
      } catch (error) {
        this.loginError();
      }
    }
  }
};
</script>

<style scoped lang="css">
.modern-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.modern-page-header__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-page-header__icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #1565C0, #0d47a1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modern-page-header__icon {
  color: #ffffff !important;
  font-size: 22px !important;
}

.modern-page-header__title {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.3px;
}

.modern-page-header__sub {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 13px;
  color: #64748b;
  margin: 2px 0 0;
}

.modern-add-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 10px !important;
  height: 40px !important;
  padding: 0 18px !important;
  letter-spacing: 0.2px !important;
}

.modern-table-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.modern-table-toolbar {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  gap: 8px;
}

.modern-search-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  gap: 10px;
  transition: border-color 0.2s ease;
  max-width: 360px;
}

.modern-search-wrap:focus-within {
  border-color: #1565C0;
  background: #ffffff;
}

.modern-search-icon {
  color: #94a3b8 !important;
  font-size: 18px !important;
}

.modern-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 14px;
  color: #334155;
  width: 100%;
}

.modern-search-input::placeholder {
  color: #94a3b8;
}

.table-row-clickable:hover {
  background: #f8fafc !important;
}

.school-name-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.school-avatar {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #1565C0, #0d47a1);
  color: #ffffff;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.table-cell-primary {
  font-weight: 600 !important;
  color: #1e293b !important;
}

.table-cell-secondary {
  color: #64748b !important;
  font-size: 14px !important;
}

.table-cell-actions {
  white-space: nowrap;
}

.level-chip {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  height: 22px !important;
  border-radius: 6px !important;
}

.table-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 500 !important;
  text-transform: none !important;
  border-radius: 7px !important;
  height: 30px !important;
  min-width: unset !important;
  padding: 0 10px !important;
  font-size: 12px !important;
  margin: 0 2px !important;
}

.table-action-btn--primary {
  box-shadow: 0 2px 6px rgba(21, 101, 192, 0.3) !important;
}

.modern-empty-state {
  padding: 60px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.modern-empty-state__icon {
  font-size: 48px !important;
  color: #cbd5e1 !important;
}

.modern-empty-state__text {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 15px;
  color: #94a3b8;
  margin: 0;
}
</style>
